import $ from 'domtastic';
import axios from 'axios';
import Animations from './NewsletterAnimations';

class Newsletter {
  constructor() {
    this.cacheDom();
    this.bindEvents();
  }

  cacheDom() {
    this.$root = $('.js-newsletter');
    this.$form = $('.js-newsletter-form');
    this.$input = $('.js-newsletter-input');
    this.$button = $('.js-newsletter-button');
    this.$error = $('.js-newsletter-error');
    this.$success = $('.js-newsletter-success');
    this.$message = $('.js-newsletter-message');
    this.$back = $('.js-newsletter-back');
    this.$checkmark = $('.js-newsletter-checkmark');
  }

  bindEvents() {
    this.$form.on('submit', (event) => {
      event.preventDefault();
      if (this.loading) return;
      this.submit(event);
    });

    this.$back.on('click', (event) => {
      event.preventDefault();
      this.back();
    });
  }

  // Handles submit
  submit(event) {
    this.loadingState(true);
    const formData = new FormData(event.currentTarget);
    this.toggleMessage(false);
    this.request(formData);
    this.$input.val('');
  }

  // Make the request and go to done() with boolean succeed and error message on fail
  request(data) {
    axios.post('/wp-json/app/v1/email', data)
      .then(response => this.done(response.status))
      .catch(error => this.done(error.response.status));
  }

  // On success return success function, else fail function
  done(status) {
    this.loadingState(false);
    const didSucceed = status === 200;
    if (didSucceed) return this.success();
    return this.fail(status);
  }

  loadingState(isLoading = true) {
    this.loading = isLoading;
    this.$button.toggleClass('-loading', isLoading);
  }

  success() {
    this.$success.toggleClass('-visible', true);
    this.$checkmark.toggleClass('-active', true);
    Animations.slide(this.$root[0]);
  }

  // Handles all fail messages
  fail(status) {
    let message = 'Ett okänt fel uppstod.';
    let color = 'red';
    switch (status) {
      case 400:
        message = 'Ogiltig e-postadress.';
        color = 'red';
        break;
      case 409:
        message = 'E-postadressen är redan registrerad.';
        color = 'orange';
        break;
      default:
        break;
    }

    this.showError(message, color);
    Animations.shake(this.$root[0]);
  }

  showError(message, color) {
    this.$error.text(message);
    this.toggleMessage(true, color);
  }

  // Shows/hides the response/message element
  toggleMessage(show, color) {
    this.$error.removeClass('-red -orange');
    this.$error.toggleClass('-visible', show);
    if (show) this.$error.addClass(`-${color}`);
  }

  back() {
    Animations.slide(this.$root[0], true, () => {
      this.$success.toggleClass('-visible', false);
      this.$checkmark.toggleClass('-active', false);
    });
  }
}

export default new Newsletter();



// WEBPACK FOOTER //
// ./components/Newsletter.js